<div #container class="container" [ngStyle]="containerStyles">
  <div #content>
    <ng-content />
  </div>
</div>

@if (expandable) {
  <div>
    @if (!expanded) {
      <span>
        (<a href="#" (click)="onExpandClick($event, true)">more</a>)
      </span>
    }
    @if (expanded) {
      <span>
        (<a href="#" (click)="onExpandClick($event, false)">less</a>)
      </span>
    }
  </div>
}
